function GiveFocusDirective() {
  return {
    restrict: 'A',
    scope: {
      giveFocus: '='
    },
    link: function (scope, element) {
      scope.$watch('giveFocus', (currentValue, previousValue) => {
        if (currentValue) {
          element.focus();
        } else if (currentValue === false && previousValue) {
          element.blur();
        }
      });
    }
  };
}

GiveFocusDirective.$inject = [];

export default GiveFocusDirective;



// WEBPACK FOOTER //
// ./src/directives/giveFocus.js